import { FieldsAPI, LocalLedgerFieldsRequest, getFeatureAcres } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import bboxPolygon from '@turf/bbox-polygon'
import { QUERY_KEY } from './queryKey'

const MAX_ACREAGE = 100_000

const queryIsValid = (query?: LocalLedgerFieldsRequest) => {
  if (!query) return false

  const [minX, minY] = query.lowerLeft
  const [maxX, maxY] = query.upperRight

  const bboxFeature = bboxPolygon([minX, minY, maxX, maxY])

  const acres = getFeatureAcres([bboxFeature])

  return acres < MAX_ACREAGE
}

export const useLocalLedgerFields = (query?: LocalLedgerFieldsRequest, options?: any) => {
  return useQuery(
    [QUERY_KEY.LOCAL_LEDGER, query],
    () => {
      if (!query) return
      return FieldsAPI.localLedgerFields(query)
    },
    {
      enabled: queryIsValid(query),
      keepPreviousData: true,
      ...options,
    }
  )
}
